<div mat-dialog-title class="row d-flex justify-content-between align-items-center">  
  <h3 class="text-muted mr-3">Meu Avatar</h3>    
  <button mat-icon-button class="ml-5" (click)="closeDialog()">
    <mat-icon>clear</mat-icon>
  </button>
</div>

<div *ngIf="!isUploading">
  <div mat-dialog-content class="text-center">
    <img [src]="previewUrl" class="img-rounded img-circle img-responsive mat-elevation-z2 mx-auto">
    <div class="w-100 mx-auto text-center mt-2">
      <input 
        type="file" 
        id="file" 
        accept="image/*" 
        (change)="fileProgress($event)"
        enctype="multipart/form-data"
      >
      <label for="file" class="mat-elevation-z2">             
        <i class="fas fa-exchange-alt"></i> Trocar imagem
      </label>    
    </div>  
  </div>
  
  <div class="w-100 mt-4">
    <button 
      class="btn btn-primary btn-block"
      [disabled]="isUploading || !fileData"
      (click)="onUpload()"
    >
      <i class="fas fa-save"></i> Salvar imagem
    </button>
  </div>
</div>

<div class="box mx-auto" *ngIf="isUploading">
  <h2 class="text">Progress</h2>
  <progressbar 
    [value]="progress" 
    type="danger" 
    [striped]="true"
    [animate]="true"    
  >{{progress}}%</progressbar>  
</div>